import { BaseNotification } from '@notify/models/notification/types/base';

export class LowBalance extends BaseNotification {
  constructor(data) {
    super(data);
  }

  getTheme() {
    return BaseNotification.THEME_WARNING;
  }

  getI18nProps() {
    return {
      path: `notify.notification.low_balance.body`
    };
  }
}
